export const ADD_CONTRAGENT_GROUP = 'ADD_CONTRAGENT_GROUP'
export const FETCH_CONTRAGENT_GROUP = 'FETCH_CONTRAGENT_GROUP'
export const DELETE_CONTRAGENT_GROUP = 'DELETE_CONTRAGENT_GROUP'
